import React, { useState } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import './CloseUp.css';
import { useRef } from 'react';

const CloseUp = ({ setCroppedImage }) => {
    const [crop, setCrop] = useState({ unit: "%", x: 0, y: 0, width: 50, height: 62.5, aspect: 0.8 });
    const [src, setSrc] = useState(null);
    const [croppedImageUrl, setCroppedImageUrl] = useState(null);
    const imageRef = useRef(null);

    const onSelectFile = e => {
        if (e.target.files && e.target.files.length > 0) {
            const reader = new FileReader();
            reader.addEventListener("load", () => setSrc(reader.result));
            reader.readAsDataURL(e.target.files[0]);
        }
    };

    const onImageLoaded = image => {
        imageRef.current = image;
    };

    const onCropComplete = crop => {
        makeClientCrop(crop);
    };

    const onCropChange = (crop) => {
        setCrop(crop);
    };

    const makeClientCrop = async (crop) => {
        if (imageRef && crop.width && crop.height) {
            try {
                const uniqueId = Date.now();
                const fileName = `newFile_${uniqueId}.jpeg`;
                const { fileUrl, blob } = await getCroppedImg(imageRef, crop, fileName);
                setCroppedImageUrl(fileUrl);
                setCroppedImage(blob);
            } catch (error) {
                console.error('Error during image cropping:', error);
            }
        }
    }

    const getCroppedImg = (imageRef, crop, fileName) => {
        if (!crop.width || !crop.height) return;

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const pixelRatio = window.devicePixelRatio;
        ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);

        const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
        const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
        canvas.width = crop.width * scaleX;
        canvas.height = crop.height * scaleY;

        ctx.drawImage(
            imageRef.current,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width * scaleX,
            crop.height * scaleY
        );

        return new Promise((resolve, reject) => {
            canvas.toBlob(blob => {
                if (!blob) {
                    console.error('Canvas is empty');
                    reject(new Error('Canvas is empty'));
                    return;
                }
                blob.name = fileName;
                let fileUrl = window.URL.createObjectURL(blob);
                resolve({ fileUrl, blob });
            }, 'image/jpeg', 1);
        });
    };

    return (
        <div>
            <div>
                <input className="form-control"
                    type="file"
                    accept="image/*"
                    onChange={onSelectFile} />
            </div>
            <div className="image-container">
                <div className="d-flex justify-content-start">
                    {src && (
                        <ReactCrop
                            src={src}
                            crop={crop}
                            ruleOfThirds
                            onImageLoaded={onImageLoaded}
                            onComplete={onCropComplete}
                            onChange={onCropChange}
                        />
                    )}
                </div>
            </div>

            <div >
                {croppedImageUrl && (
                    <img alt="Crop" src={croppedImageUrl}
                        style={{ width: 0, height: 0, position: 'absolute', visibility: 'hidden' }} />
                )}
            </div>
        </div>
    );
}

export default CloseUp;